import React from 'react';

import { Period, Plan } from 'pages/Landings/sections/Pricing/types';

import BasicPlanSummary from '../BasicPlanSummary';
import FreePlanSummary from '../FreePlanSummary';
import OemPlanSummary from '../OemPlanSummary';
import ProPlanSummary from '../ProPlanSummary';

interface Props {
    plan: Plan;
    period: Period;
    className?: string;
}

const PlanSummary: React.FC<Props> = ({ plan, period, className }) => {
    switch (plan) {
        case Plan.FREE:
            return <FreePlanSummary className={className} />;
        case Plan.BASIC:
            return <BasicPlanSummary period={period} className={className} />;
        case Plan.PRO:
            return <ProPlanSummary period={period} className={className} />;
        case Plan.OEM:
            return <OemPlanSummary className={className} />;
        default:
            return null;
    }
};

export default PlanSummary;
